//alphabetical order
import cs_CZ from './contact-detail/cs_CZ.js'
import da_DK from './contact-detail/da_DK.js'
import de_AT from './contact-detail/de_AT.js'
import de_CH from './contact-detail/de_CH.js'
import de_DE from './contact-detail/de_DE.js'
import de_LU from './contact-detail/de_LU.js'
import en_AE from './contact-detail/en_AE.js'
import en_AU from './contact-detail/en_AU.js'
import en_CA from './contact-detail/en_CA.js'
import en_EN from './contact-detail/en_EN.js'
import en_GB from './contact-detail/en_GB.js'
import en_IE from './contact-detail/en_IE.js'
import en_LV from './contact-detail/en_LV.js'
import en_MT from './contact-detail/en_MT.js'
import en_LU from './contact-detail/en_LU.js'
import en_NO from './contact-detail/en_NO.js'
import en_SG from './contact-detail/en_SG.js'
import es_CL from './contact-detail/es_CL.js'
import es_ES from './contact-detail/es_ES.js'
import fr_BE from './contact-detail/fr_BE.js'
import fr_CH from './contact-detail/fr_CH.js'
import fr_FR from './contact-detail/fr_FR.js'
import fr_LU from './contact-detail/fr_LU.js'
import hr_HR from './contact-detail/hr_HR.js'
import hu_HU from './contact-detail/hu_HU.js'
import it_CH from './contact-detail/it_CH.js'
import it_IT from './contact-detail/it_IT.js'
import lv_LV from './contact-detail/lv_LV.js'
import nl_NL from './contact-detail/nl_NL.js'
import no_NO from './contact-detail/no_NO.js'
import pl_PL from './contact-detail/pl_PL.js'
import pt_BR from './contact-detail/pt_BR.js'
import pt_PT from './contact-detail/pt_PT.js'
import en_US from './contact-detail/en_US.js'
import tr_TR from './contact-detail/tr_TR.js'
import sl_SI from './contact-detail/sl_SI.js'
import sv_SE from './contact-detail/sv_SE.js'
import en_RO from './contact-detail/en_RO.js'
import ro_RO from './contact-detail/ro_RO.js'
import sk_SK from './contact-detail/sk_SK.js'
import fi_FI from './contact-detail/fi_FI.js'

const countrySettings = {
  'default': {
    'clocks': [
      'clock0800_1000',
      'clock1000_1200',
      'clock1200_1400',
      'clock1400_1600',
      'clock1600_1800'
    ],
    'permanentRequiredFields': [
      'RequestInterest',
      'Salutation',
      'FirstName',
      'LastName',
      'Email',
      'State'

    ],
    'requiredFields': {
      'default': [
        'Company',
        'PostalCode'
      ],
      'consulting': [
        'Company',
        'PostalCode',
        'RequestTopic'
      ],
      'offersGeneral': [
        'Company',
        'PostalCode',
        'RequestTopic'
      ],
      'offersInvestment': [
        'PostalCode'
      ],
      'other': [
        'RequestMessage'
      ],
      'customer_serviceGeneral': [
        'Company',
        'PostalCode',
        'RequestTopic',
        'RequestMessage'
      ],
      'customer_serviceBank': [
        'RequestTopic',
        'RequestMessage'
      ],
      'investor_relations': [
        'RequestMessage',
        'CustomerType'
      ],
      'career': [
        'RequestMessage'
      ],
      'press': [
        'RequestMessage'
      ],
      'cooperation': [
        'Company',
        'PostalCode',
        'RequestTopic',
        'RequestMessage'
      ]
    },
  },
  'cs_CZ': cs_CZ,
  'da_DK': da_DK,
  'de_AT': de_AT,
  'de_CH': de_CH,
  'de_DE': de_DE,
  'en_AU': en_AU,
  'en_EN': en_EN,
  'fr_CH': fr_CH,
  'it_CH': it_CH,
  'en_GB': en_GB,
  'pt_PT': pt_PT,
  'nl_NL': nl_NL,
  'fr_FR': fr_FR,
  'pl_PL': pl_PL,
  'hu_HU': hu_HU,
  'it_IT': it_IT,
  'en_IE': en_IE,
  'en_LV': en_LV,
  'es_ES': es_ES,
  'en_US': en_US,
  'tr_TR': tr_TR,
  'es_CL': es_CL,
  'fr_BE': fr_BE,
  'nl_BE': fr_BE,
  'en_SG': en_SG,
  'en_AE': en_AE,
  'sv_SE': sv_SE,
  'sk_SK': sk_SK,
  'pt_BR': pt_BR,
  'en_CA': en_CA,
  'fr_CA': en_CA,
  'en_NO': en_NO,
  'no_NO': no_NO,
  'en_RO': en_RO,
  'ro_RO': ro_RO,
  'fi_FI': fi_FI,
  'hr_HR': hr_HR,
  'fr_LU': fr_LU,
  'de_LU': de_LU,
  'en_LU': en_LU,
  'sl_SI': sl_SI,
  'lv_LV': lv_LV,
  'en_MT': en_MT
}

function countryClocks (countryCode) {
  return countrySettings[countryCode] && countrySettings[countryCode].clocks ? countrySettings[countryCode].clocks : countrySettings['default'].clocks
}

function countryPermanentRequiredFields (countryCode) {
  return countrySettings[countryCode] && countrySettings[countryCode].permanentRequiredFields ? countrySettings[countryCode].permanentRequiredFields : countrySettings['default'].permanentRequiredFields
}

function countryRequiredFields (countryCode, interest) {
  let requiredFields = [].concat(
    countryPermanentRequiredFields(countryCode),
    countryClocks(countryCode),
    countrySettings[countryCode] && countrySettings[countryCode].requiredFields && countrySettings[countryCode].requiredFields[interest] ? countrySettings[countryCode].requiredFields[interest] : countrySettings['default'].requiredFields[interest]
  )

  return requiredFields
}

export {
  countryClocks,
  countryRequiredFields,
  countryPermanentRequiredFields
}
